import { ReactElement, useState } from 'react';
import { Button, Classes, Dialog } from '@blueprintjs/core';
import { RestoreUser } from '..';
import { User } from '@techshift/callie-private-api-typescript';

export type RestoreUserButtonProps = {
	user: User;
	onSuccess?: (user: User) => void;
};
export function RestoreUserButton(props: RestoreUserButtonProps): ReactElement {
	const { user, onSuccess } = props;

	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<Button
				onClick={() => {
					setIsOpen(true);
				}}
			>
				Restore
			</Button>
			<Dialog isOpen={isOpen}>
				<div className={Classes.DIALOG_BODY}>
					<RestoreUser
						user={user}
						onSuccess={(user) => {
							onSuccess?.(user);
							setIsOpen(false);
						}}
					/>
				</div>
				<div className={Classes.DIALOG_FOOTER}>
					<div className={Classes.DIALOG_FOOTER_ACTIONS}>
						<Button
							onClick={() => {
								setIsOpen(false);
							}}
						>
							Close
						</Button>
					</div>
				</div>
			</Dialog>
		</>
	);
}
